import React from 'react';

export default props => {
  const link = `https://www.twitter.com/${props.account}`
  return (
    <a rel="noopener noreferrer" className="link" href={link}  target="_blank">@{props.account}</a>
  )
}